const {
  produce
} = require("immer");

const initialState = {
  api: {},
  app: {},
  chat: {},
  group: {},
  guest: {},
  invitation: {},
  licence: {},
  member: {},
  message: {},
  platform: {},
  profile: {},
  project: {},
  registration: {},
  role: {},
  service: {},
  theme: {},
  user: {},
  backend: {},
  folder: {},
  file: {},
  task: {},
  database: {},
}

module.exports = function (state = initialState, action) {
  switch (action.type) {

    case "SET_STATE":
      return produce(state, draft => {
        Object.keys(action.state)
          .filter(k => !(k in draft))
          .forEach(k => draft[k] = {})
      })

    case "UPDATE_ELEMENTS":
      return produce(state, draft => {
        let {
          key,
          elements
        } = action;
        if (!draft[key]) {
          console.warn(`MISSING KEY ${key} IN INIT STATE !!!`);
          draft[key] = {}
        }
        elements.forEach(e => draft[key][e.uid] = e)
      });

    case "DELETE_ELEMENTS":
      return produce(state, draft => {
        let { key, uids } = action
        uids.filter(uid => uid in draft[key]).forEach(uid => delete draft[key][uid])
      });

    case "UPDATE_ALL_ELEMENTS":
      return produce(state, draft => {
        for (let { type, elements } of action.elements) {
          for (let e of elements) draft[type][e.uid] = e
        }
      });

    case "DELETE_ALL_ELEMENTS":
      return produce(state, draft => {
        Object.entries(action.toClean).forEach(([type, uuids]) => uuids.forEach(uid => {
          if (uid in draft[type]) delete draft[type][uid];
        }));
      });
    default:
      return state;
  }
}